import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import LoadingScreen from '~/components/LoadingScreen';
import { useUserBankAccountPermissions } from '~/hooks/useUserBankAccountPermissions';
import { RouteConfig } from '~/routes/routeConfig';

const CardsGuard = ({ children }: { children: ReactNode }) => {
  const { isSibillAccountEnabled, isLoading } = useUserBankAccountPermissions();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isSibillAccountEnabled) {
    return <Navigate to={RouteConfig.AppRoot.buildLink()} replace />;
  }

  return <>{children}</>;
};

export default CardsGuard;
